<div class="left-navigation"
  [class.collapsed]="isCollapsed"
  [class.navigation-disabled]="disabled"
  [class.disable-page]="isDisablePage"
  [class.mobile-open]="mobileMenuOpen">

  <!-- Mobile Overlay (click to close) -->
  <div
    class="mobile-overlay"
    *ngIf="mobileMenuOpen"
    (click)="closeMobileMenu()"
    aria-label="Close navigation menu"></div>

  <!-- Header with Logo and Toggle Button -->
  <div class="navigation-header">
    <div class="logo-section" *ngIf="showExpandedContent" (click)="onLogoClick()" style="cursor: pointer;">
      <div class="logo-icon">
        <img src="../../assets/images/covestro.svg" alt="Logo" />
      </div>
      <span class="logo-text">Cargo Cockpit</span>
    </div>
    <div class="logo-icon-only" *ngIf="!showExpandedContent" (click)="onLogoClick()" style="cursor: pointer;">
      <img src="../../assets/images/covestro.svg" alt="Logo" />
    </div>

    <!-- Close button for mobile view -->
    <button
      class="mobile-close-button"
      mat-icon-button
      (click)="closeMobileMenu()"
      aria-label="Close navigation menu">
      <mat-icon>close</mat-icon>
    </button>

    <!-- Toggle Button Container to maintain layout -->
    <div class="toggle-button-container">
      <button *ngIf="showToggleButton" mat-icon-button class="toggle-button" (click)="onToggleButtonClick()"
        [class.collapsed]="isMobileOrTablet ? !mobileMenuOpen : isCollapsed">
        <mat-icon>{{ (isMobileOrTablet ? !mobileMenuOpen : isCollapsed) ? 'chevron_right' : 'chevron_left' }}</mat-icon>
      </button>
    </div>
  </div>

  <!-- Navigation Menu -->
  <div class="navigation-content-container">
    <div class="navigation-content">
      @for (item of menuItems; track $index) {
      <div class="menu-item" [class.active]="item.active">
        <!-- Main Menu Item -->
        <div class="menu-item-main" [class.has-submenu]="item.hasSubmenu && showExpandedContent"
          (click)="onMenuItemClick(item)">
          <div class="menu-item-content">
            <mat-icon class="menu-icon" [svgIcon]="item.icon"></mat-icon>
            <span class="menu-text" *ngIf="showExpandedContent">{{ item.name | translate }}</span>
            <mat-icon class="expand-icon" *ngIf="item.hasSubmenu && showExpandedContent">
              {{ item.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
          </div>
        </div>

        <!-- Submenu Items -->
        <div class="submenu" *ngIf="item.submenu && item.expanded && showExpandedContent">
          <div class="submenu-item" *ngFor="let subitem of item.submenu" [class.active]="subitem.active"
            (click)="onSubmenuItemClick(subitem)">
            <span class="submenu-text">{{ subitem.name | translate }}</span>
            <span class="beta-chip" *ngIf="subitem.beta">{{ 'common.beta' | translate }}</span>
          </div>
        </div>
      </div>
      }

    </div>
  </div>

  <!-- Support Contact - pinned to bottom -->
  <div class="support-section" [class.collapsed]="!showExpandedContent">
    <div class="support-item" (click)="onSupportClick()">
      <mat-icon class="support-icon" [svgIcon]="IconName.NAV_SUPPORT"></mat-icon>
      <span class="support-text" *ngIf="showExpandedContent">
        {{ 'navigation.helpSupport' | translate }}
      </span>
    </div>
  </div>

</div>